module.exports = __webpack_public_path__ + "@/assets/img/double-check.5994432e.svg";